var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "epf-filter__select", class: _vm.additionalClass },
    [
      _c("div", { staticClass: "epf-filter__select__title" }, [
        _vm._v(_vm._s(_vm.filterConfig.title)),
      ]),
      _vm._v(" "),
      _vm.filterConfig.type === "colorselect"
        ? [
            _vm.selectedOption
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "epf-filter__select__selection epf-filter__select__selection--color",
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "swatches" },
                        [
                          _vm._l(_vm.selectedOption.colors, function (color) {
                            return _c("span", {
                              staticClass: "swatch",
                              style: "background-color: #" + color + ";",
                            })
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "swatch__title",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.selectedOption.title || _vm.selectedOption
                              ),
                            },
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.showDeselect
                        ? _c("global-button", {
                            staticClass: "epf-filter__select__clear",
                            attrs: {
                              icon: "close",
                              theme: "primary",
                              disabled: _vm.freeze,
                            },
                            on: { click: _vm.onClearSelection },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              : [
                  _c("global-dropdown", {
                    attrs: {
                      options: _vm.availableOptionsForDropdown,
                      "initial-title": _vm.$t("filter.dropdown.pleaseSelect"),
                      "selected-option": _vm.selectedOptionForDropdown,
                      disabled:
                        _vm.freeze ||
                        _vm.availableOptionsForDropdown.length === 0,
                    },
                    on: { change: _vm.onOptionSelection },
                  }),
                ],
          ]
        : [
            _vm.selectedOption
              ? [
                  _c(
                    "div",
                    { staticClass: "epf-filter__select__selection" },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.selectedOption.title || _vm.selectedOption
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _vm.showDeselect
                        ? _c("global-button", {
                            staticClass: "epf-filter__select__clear",
                            attrs: {
                              icon: "close",
                              theme: "primary",
                              disabled: _vm.freeze,
                            },
                            on: { click: _vm.onClearSelection },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              : [
                  _c("global-dropdown", {
                    attrs: {
                      options: _vm.availableOptionsForDropdown,
                      "initial-title": _vm.$t("filter.dropdown.pleaseSelect"),
                      "selected-option": _vm.selectedOptionForDropdown,
                      disabled:
                        _vm.freeze ||
                        _vm.availableOptionsForDropdown.length === 0,
                    },
                    on: { change: _vm.onOptionSelection },
                  }),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }